import { Link } from 'react-router-dom'

function TermsOfService() {
    return (
        <>
            <section className='other-pages'>
                <div className="container">
                    <h3>Terms of Service</h3>
                </div>
            </section>
            <section className='other-pages-details'>
                <div className="container">

                    <ul className='mb-3 custom-ul'>
                        <li>
                            Always Outdoors – Terms of Service
                        </li>
                        <li>
                            Effective Date: <b>June 11th, 2025</b>
                        </li>
                        <li>
                            Last Updated: <b>June 11th, 20254</b>
                        </li>
                    </ul>
                    <h6 className='mb-4'>Welcome to Always Outdoors! These Terms of Service (“Terms”) govern your access to and use of the Always Outdoors mobile application, website, and related services (collectively, the “Service”) provided by Always Outdoors LLC (“Always Outdoors,” “we,” “us,” or “our”).
                        By creating an account or using the Service, you agree to be bound by these Terms. If you do not agree, do not use the Service
                    </h6>
                    <div className='mb-3'>
                        <h5 className='mb-3'>1. Eligibility</h5>
                        <h6>You must be at least 18 years old to use Always Outdoors. By creating an account or using the Service, you confirm that you are 18 years of age or older.</h6>
                    </div>
                    <div className='mb-3'>
                        <h5 className='mb-3'>2. Your Account</h5>
                        <h6 className='mb-3'>
                            You are responsible for keeping your login credentials secure.
                        </h6>
                        <h6 className='mb-3'>
                            You must not create an account using false information or on behalf of someone else without permission.
                        </h6>
                        <h6>
                            You agree not to use the Service for unlawful or prohibited activities.
                        </h6>
                    </div>
                    <div className='mb-3'>
                        <h5 className='mb-3'>3. User Conduct</h5>
                        <h6 className='mb-3'>
                            You agree not to:
                            <br />
                            Harass, threaten, or harm others.

                        </h6>
                        <h6 className='mb-3'>
                            Post or share content that is hateful, obscene, sexually explicit, violent, or illegal.
                        </h6>
                        <h6 className='mb-3'>
                            Use the Service to promote third-party services without authorization.
                        </h6>
                        <h6>
                            Engage in data mining, scraping, or automated access to the platform.
                        </h6>
                    </div>
                    <div className='mb-3'>
                        <h5 className='mb-3'>4. Content and Usage Rights</h5>
                        <h6 className='mb-3'>
                            You retain ownership of the content you post but grant us a worldwide, royalty-free license to use, host, display, and distribute it to operate and promote the Service.
                        </h6>
                        <h6>
                            We may remove content that violates these Terms or is otherwise objectionable, at our sole discretion.

                        </h6>
                    </div>
                    <div className='mb-3'>
                        <h5 className='mb-3'>5. Privacy</h5>
                        <h6 className='mb-3'>
                            We respect your privacy. Please review our Privacy Policy to understand how we collect, use, and share your information.

                        </h6>
                    </div>
                    <div className='mb-3'>
                        <h5 className='mb-3'>6. In-App Purchases and Subscriptions</h5>
                        <h6 className='mb-3'>
                            Some features are free, while others may require payment.
                        </h6>
                        <h6 className='mb-3'>
                            Subscription services will auto-renew unless canceled before the renewal date.
                        </h6>
                        <h6>
                            Prices and availability are subject to change.
                        </h6>
                    </div>
                    <div className='mb-3'>
                        <h5 className='mb-3'>7. Advertising and Analytics</h5>
                        <h6 className='mb-3'>
                            The free version of Always Outdoors may include third-party ads.
                        </h6>
                        <h6 className='mb-3'>
                            We use analytics tools to understand user behavior and improve the Service.
                        </h6>
                        <h6>
                            Aggregated, anonymized data may be shared with partners. No personally identifiable information will be sold.
                        </h6>
                    </div>
                    <div className='mb-3'>
                        <h5 className='mb-3'>8. Termination</h5>
                        <h6>
                            You can delete your account at any time. We may suspend or terminate your access if you violate these Terms or pose a risk to the community.
                        </h6>
                    </div>
                    <div className='mb-3'>
                        <h5 className='mb-3'>9. Disclaimers</h5>
                        <h6>
                            The Service is provided “as is,” “with all faults,” and “as available,” without warranty of any kind, either express or implied, including but not limited to the implied warranties of merchantability, fitness for a particular purpose, title, and non-infringement.
                            Always Outdoors does not warrant that the Service will be uninterrupted, secure, or error-free, or that content will be accurate or reliable.
                            Always Outdoors LLC does not screen or vet users or verify event safety. You are solely responsible for exercising caution and using good judgment when interacting with other users or attending events.

                        </h6>
                    </div>
                    <div className='mb-3'>
                        <h5 className='mb-3'>10. Limitation of Liability</h5>
                        <h6 className='mb-3'>
                            To the maximum extent permitted by applicable law, Always Outdoors LLC, its affiliates, officers, employees, agents, partners, and licensors shall not be liable for any indirect, incidental, special, consequential, punitive, or exemplary damages, including but not limited to loss of profits, data, use, goodwill, or other intangible losses, arising out of or related to:
                            Your access to or use of (or inability to access or use) the Service
                        </h6>

                        <h6 className='mb-3'>
                            Any conduct or content of any user or third party on the Service

                        </h6>

                        <h6 className='mb-3'>
                            Any interactions or events arranged through the Service
                        </h6>

                        <h6 className='mb-3'>
                            Any unauthorized access, use, or alteration of your content or account
                        </h6>

                        <h6 className='mb-3'>
                            In no event shall Always Outdoors LLC’s total liability for all claims exceed the amount you paid (if any) to Always Outdoors LLC in the past twelve (12) months.
                        </h6>

                        <h6 className='mb-3'>
                            You acknowledge that you voluntarily participate in activities or meetups facilitated through the Service and assume all risks associated with such participation.
                        </h6>
                    </div>
                    <div className='mb-3'>
                        <h5 className='mb-3'>11. Governing Law</h5>
                        <h6>
                            These Terms are governed by the laws of the State of Utah, without regard to its conflict of laws principles.
                        </h6>
                    </div>
                    <div className='mb-3'>
                        <h5 className='mb-3'>12. Changes to These Terms</h5>
                        <h6>
                            We may update these Terms from time to time. We’ll notify users of material changes via the app or email.
                        </h6>
                    </div>
                    <div>
                        <h5 className='mb-3'>13. Contact Us</h5>
                        <h6 className='mb-3'>For questions about these Terms, contact us at:
                            <Link to="mailto:contact@alwaysoutdoors.org">contact@alwaysoutdoors.org</Link></h6>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TermsOfService